module.exports = __webpack_public_path__ + "static/media/Office_development_Derry.a7d2625d.jpg";